import { Injector, Component, ViewEncapsulation, Inject } from '@angular/core';
import { AppConsts } from '@shared/AppConsts';
import { AppComponentBase } from '@shared/common/app-component-base';
import { DOCUMENT } from '@angular/common';

@Component({
    templateUrl: './default-brand.component.html',
    selector: 'default-brand',
    encapsulation: ViewEncapsulation.None
})
export class DefaultBrandComponent extends AppComponentBase {
    
    defaultLogo = AppConsts.appBaseUrl + '/assets/common/images/app-logo-on-' + this.currentTheme.baseSettings.menu.asideSkin + '.svg';
    logo = `${AppConsts.appBaseUrl}/assets/common/images/logo-arvenza.png`;

    remoteServiceBaseUrl: string = AppConsts.remoteServiceBaseUrl;
    tenantLogo = (this.appSession.tenant !== undefined) ? AppConsts.remoteServiceBaseUrl + '/TenantCustomization/GetTenantLogo?skin=light&tenantId=' + this.appSession.tenant.id : this.logo;

    constructor(
        injector: Injector,
        @Inject(DOCUMENT) private document: Document
    ) {
        super(injector);
    }
 
    toggleLeftAside(): void {
        this.document.body.classList.toggle('kt-aside--minimize');
    }
}
